<mat-dialog-content>
  <mat-table [dataSource]="items" style="max-height: 525px">
    <ng-container matColumnDef="groupName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.name' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let group">
        {{ group.name }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="share">
      <mat-header-cell *matHeaderCellDef>{{ 'common.share' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let org">
        <mat-checkbox
          [checked]="org.share"
          (change)="controlActions($event, org.id, 'share')"
        ></mat-checkbox>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="columns; sticky: true"></mat-header-row>
    <mat-row matRipple *matRowDef="let org; columns: columns"> </mat-row>
  </mat-table>
</mat-dialog-content>
<mat-dialog-actions>
  <sn-flat-button color="danger" mat-dialog-close class="cancelButton">{{ 'common.cancel' | t }}</sn-flat-button>
  <sn-flat-button color="success" (click)="save()" class="saveButton">{{ 'common.save' | t }}</sn-flat-button>
</mat-dialog-actions>
